import PropTypes from 'prop-types';

export const columnType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string,
    withLink: PropTypes.bool,
});

export const sortedType = PropTypes.shape({
    desc: PropTypes.bool.isRequired,
    id: PropTypes.string.isRequired,
});

export const filteredType = PropTypes.shape({
    id: PropTypes.string.isRequired,
    value: PropTypes.string,
});

export const criteriaType = PropTypes.shape({
    page: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    sort: PropTypes.arrayOf(sortedType).isRequired,
    where: PropTypes.arrayOf(filteredType).isRequired,
});

export const metadataType = PropTypes.shape({
    page: PropTypes.number.isRequired,
    pages: PropTypes.number.isRequired,
    perPage: PropTypes.number.isRequired,
    total: PropTypes.number.isRequired,
});
